<template>
  <div class="outgoing-detail" v-if="detail != null">
    <Toast />
    <Card>
      <template #header>
        <div class="card-header-flex">
          <h4>
            <span v-if="detail.summary.type == 'TRANSFER ITEM'"
              >Detail Transfer Item</span
            >
            <span v-else>Detail Retur</span>
          </h4>
          <Button
            icon="pi pi-arrow-left"
            label="Kembali"
            class="p-button-text back-btn"
            @click="$router.back()"
          />
        </div>
      </template>
      <template #content>
        <div
          v-if="loading"
          class="p-d-flex p-jc-center p-ai-center"
          style="min-height: 200px"
        >
          <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="4" />
        </div>
        <div v-else>
          <div class="p-grid p-m-1">
            <div
              class="p-col p-mb-5"
              v-if="detail.summary.type == 'TRANSFER ITEM'"
            >
              <label>Outlet Tujuan</label>
              <div>{{ detail.summary.outlet_name_destination }}</div>
            </div>
            <div class="p-col p-mb-5">
              <label>Kode Gudang</label>
              <div>{{ detail.summary.warehouse_code }}</div>
            </div>
            <div class="p-col p-mb-5">
              <label>Nama Gudang</label>
              <div>{{ detail.summary.warehouse_name }}</div>
            </div>
            <div class="p-col p-mb-5">
              <label>Nomor Bon</label>
              <div>{{ detail.summary.doc_number }}</div>
            </div>
            <div class="p-col p-mb-5">
              <label>Tanggal Bon</label>
              <div>
                {{ detail.summary.doc_date | date }}
              </div>
            </div>
            <div class="p-col p-mb-5">
              <label>Status</label>
              <div :style="{ color: statusColor(detail.summary.status) }">
                <b>{{ statusText(detail.summary.status) }}</b>
              </div>
            </div>
            <div class="p-col-12">
              <div style="overflow-x: auto; width: 100%">
                <DataTable
                  :value="detail.outlet_outbound"
                  responsiveLayout="scroll"
                  :loading="loading"
                  scrollable
                  scrollDirection="horizontal"
                  style="min-width: 900px; width: 100%"
                >
                  <Column
                    header="No"
                    headerStyle="width: 3rem; text-align: center;"
                    bodyStyle="width: 3rem; text-align: center;"
                  >
                    <template #body="slotProps">
                      {{ slotProps.index + 1 }}
                    </template>
                  </Column>
                  <Column
                    field="item_code"
                    header="Kode Barang"
                    headerStyle="width: 8rem;"
                    bodyStyle="width: 8rem;"
                  />
                  <Column
                    field="item_name"
                    header="Nama Barang"
                    headerStyle="width: 12rem;"
                    bodyStyle="width: 12rem;"
                  />
                  <Column
                    field="category_code"
                    header="Kode Kategori"
                    headerStyle="width: 7rem;"
                    bodyStyle="width: 7rem;"
                  />
                  <Column
                    field="supplier_code"
                    header="Kode Supplier"
                    headerStyle="width: 7rem;"
                    bodyStyle="width: 7rem;"
                  />
                  <Column
                    v-if="detail.summary.type != 'TRANSFER ITEM'"
                    field="description"
                    header="Deskripsi"
                    :body="descBody"
                    headerStyle="width: 10rem;"
                    bodyStyle="width: 10rem;"
                  />
                  <Column
                    field="price"
                    header="Harga"
                    headerStyle="width: 7rem; text-align: right;"
                    bodyStyle="width: 7rem; text-align: right;"
                  >
                    <template #body="slotProps">
                      {{ slotProps.data.price | currency }}
                    </template>
                  </Column>
                  <Column
                    field="qty"
                    header="Jumlah"
                    headerStyle="width: 5rem; text-align: right;"
                    bodyStyle="width: 5rem; text-align: right;"
                  />
                  <Column
                    field="total"
                    header="Total Harga"
                    headerStyle="width: 9rem; text-align: right;"
                    bodyStyle="width: 9rem; text-align: right;"
                  >
                    <template #body="slotProps">
                      {{ slotProps.data.total | currency }}
                    </template>
                  </Column>
                  <Column
                    v-if="user.role == 'OUTLET_MANAGER'"
                    header="Aksi"
                    headerStyle="width: 7rem; text-align: center;"
                    bodyStyle="width: 7rem; text-align: center;"
                  >
                    <template #body="slotProps">
                      <Button
                        v-if="
                          slotProps.data.status == 0 &&
                          detail.summary.type != 'TRANSFER ITEM'
                        "
                        label="Disetujui"
                        class="p-button-primary"
                        @click="onApproveBtnClick(slotProps.data)"
                      />
                      <Button
                        v-else-if="
                          slotProps.data.status == 0 &&
                          detail.summary.type == 'TRANSFER ITEM'
                        "
                        label="Disetujui"
                        class="p-button-primary"
                        @click="onApproveBtnClickTransfer(slotProps.data)"
                      />
                    </template>
                  </Column>
                </DataTable>
              </div>
              <div class="summary-row">
                <div class="summary-total">
                  <span class="total-label">Total Qty</span>
                  <span class="total-qty">{{ detail.summary.total_qty }}</span>
                  <span class="total-label">Total Harga</span>
                  <span class="total-price">{{
                    detail.summary.total_price | currency
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="p-d-flex p-jc-end p-mt-3" style="gap: 1rem">
            <Button
              v-if="user.role == 'OUTLET_MANAGER' && detail.summary.status == 1"
              icon="pi pi-print"
              label="Print"
              class="p-button-primary"
              :disabled="loading"
              @click="printPage"
            />
            <Button
              v-if="
                user.role == 'OUTLET_MANAGER' &&
                detail.summary.status == 1 &&
                detail.summary.type == 'RETURN'
              "
              icon="pi pi-file-excel"
              label="Export"
              class="p-button-success"
              :disabled="loading"
              @click="getOutletOutgoingCSV"
            />
            <Button
              v-if="
                user.role == 'OUTLET_MANAGER' &&
                detail.summary.status == 1 &&
                detail.summary.type == 'TRANSFER ITEM'
              "
              icon="pi pi-file-excel"
              label="Transfer"
              class="p-button-success"
              :disabled="loading"
              @click="getOutletOutgoingTransferCSV"
            />
          </div>
        </div>
      </template>
    </Card>
    <Dialog
      :visible.sync="confirmDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengkonfirmasi ? </span>
      </div>
      <template #footer>
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check "
          class="btn btn-primary"
          @click="postOutlets()"
        >
          APPROVE
          <span v-if="loading_approve">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>

    <Dialog
      :visible.sync="confirmTransferDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Apakah kamu yakin ingin mengkonfirmasi ? </span>
      </div>
      <template #footer>
        <Button
          type="button"
          label="Yes"
          icon="pi pi-check "
          class="btn btn-primary"
          @click="postOutletsTransfer()"
        >
          APPROVE
          <span v-if="loading_approve">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>

    <Dialog
      :visible.sync="deleteDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span> Stok bisa mencapai minus, hapus barang ini? </span>
      </div>
      <template #footer>
        <Button
          type="button"
          class="btn btn-danger"
          @click="deleteItemOutletOutgoing()"
        >
          Hapus
          <span v-if="loading_approve">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import ProgressSpinner from 'primevue/progressspinner'

let moment = require('moment')
export default {
  components: { Card, DataTable, Column, Button, ProgressSpinner },
  data() {
    return {
      moment: moment,
      loading: true,
      products: null,
      loading_approve: false,
      expandedRows: [],
      detail: null,
      confirmDialog: false,
      confirmTransferDialog: false,
      outlet_inbound_data: null,
      deleteDialog: false
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getOutlets()
  },
  methods: {
    statusText(status) {
      switch (status) {
        case 0:
          return 'Pending'
        case 1:
          return 'Confirmed'
        case 2:
          return 'Tolak'
        case 3:
          return 'Completed'
        default:
          return ''
      }
    },
    statusColor(status) {
      switch (status) {
        case 0:
          return 'red'
        case 1:
          return 'green'
        case 2:
          return 'red'
        case 3:
          return 'blue'
        default:
          return ''
      }
    },
    priceBody(row) {
      return this.$options.filters.currency
        ? this.$options.filters.currency(row.price)
        : row.price
    },
    totalBody(row) {
      return this.$options.filters.currency
        ? this.$options.filters.currency(row.total)
        : row.total
    },
    descBody(row) {
      return row.description && row.description !== '' ? row.description : '-'
    },
    actionBody(row, _opts) {
      if (
        row.status != 1 &&
        row.status != 3 &&
        row.status != 2 &&
        this.user.role == 'OUTLET_MANAGER'
      ) {
        console.log('row: ', row)
        if (this.detail.summary.type != 'TRANSFER ITEM') {
          return (
            <Button
              label="Disetujui"
              class="p-button-primary"
              onClick={() => this.onApproveBtnClick(row)}
            />
          )
        } else {
          return (
            <Button
              label="Disetujui"
              class="p-button-primary"
              onClick={() => this.onApproveBtnClickTransfer(row)}
            />
          )
        }
      }
      return null
    },
    onApproveBtnClick(outlet_inbound) {
      this.outlet_inbound_data = outlet_inbound
      this.confirmDialog = true
    },

    onApproveBtnClickTransfer(outlet_inbound) {
      this.outlet_inbound_data = outlet_inbound
      this.confirmTransferDialog = true
    },

    async getOutletOutgoingCSV() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbounds/csv?doc_number=${this.$route.query.doc_number}`,
          { responseType: 'blob' }
        )

        if (response.status === 200) {
          let blob = new Blob([response.data], {
            type: response.headers['content-type']
          })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${this.detail.summary.doc_number}.csv`
          link.click()
        }
      } catch (error) {
        console.error('Error while downloading CSV:', error)
      }
    },

    async getOutletOutgoingTransferCSV() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/transfer-item/csv?doc_number=${this.$route.query.doc_number}`,
          { responseType: 'blob' }
        )

        if (response.status === 200) {
          let blob = new Blob([response.data], {
            type: response.headers['content-type']
          })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${this.detail.summary.doc_number}.csv`
          link.click()
        }
      } catch (error) {
        console.error('Error while downloading Transfer CSV:', error)
      }
    },

    printPage() {
      this.$router.push({
        name: 'print-retur-bon',
        params: { detail: this.detail }
      })
    },

    async getOutlets() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbound?doc_number=${this.$route.query.doc_number}`
        )

        if (response.status === 200) {
          this.detail = response.data.data
          for (let i = 0; i < this.detail.outlet_outbound.length; i++) {
            if (
              this.detail.outlet_outbound[i].status == 1 &&
              this.detail.outlet_outbound[i].received_at !== '' &&
              this.detail.outlet_outbound[i].received_by !== '' &&
              i === this.detail.outlet_outbound.length - 1
            ) {
              this.detail.summary.status = 2
            }
          }
        } else {
          console.error('Error while fetching outlets')
        }
      } catch (error) {
        console.error('Error while fetching outlets:', error)
      } finally {
        this.loading = false
      }
    },

    async postOutlets() {
      this.loading_approve = true
      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbounds/${this.outlet_inbound_data.id}/confirm`
        )

        this.confirmDialog = false
        this.loading_approve = false

        if (response.status === 200) {
          this.showToast('success', 'Return Success', 'Konfirmasi Berhasil')
          this.getOutlets()
        } else if (response.data.message === 'error.post.item_negative_stock') {
          this.showToast('error', 'Return Failed', 'Stok Tidak Mencukupi')
          setTimeout(() => {
            this.deleteDialog = true
          }, 300)
        } else {
          this.showToast('error', 'Return Failed', 'Konfirmasi Gagal')
        }
      } catch (error) {
        this.loading_approve = false
        this.showToast(
          'error',
          'Return Failed',
          'Terjadi kesalahan pada server'
        )
        console.error('Error while posting outlet confirmation:', error)
      }
    },

    async postOutletsTransfer() {
      this.loading_approve = true
      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_API_URL}/dashboard/transfer-item/${this.outlet_inbound_data.id}/confirm`
        )

        this.confirmTransferDialog = false
        this.loading_approve = false

        if (response.status === 200) {
          this.showToast('success', 'Return Success', 'Konfirmasi berhasil')
          this.getOutlets()
        } else if (response.data.message === 'error.post.item_negative_stock') {
          this.showToast('error', 'Return Failed', 'Stok tidak mencukupi')
          setTimeout(() => {
            this.deleteDialog = true
          }, 300)
        } else {
          this.showToast('error', 'Return Failed', 'Konfirmasi gagal')
        }
      } catch (error) {
        this.loading_approve = false
        this.showToast(
          'error',
          'Return Failed',
          'Terjadi kesalahan pada server'
        )
        console.error('Error while posting transfer confirmation:', error)
      }
    },

    async deleteItemOutletOutgoing() {
      this.loading_approve = true
      try {
        const response = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/outlet-outbounds/${this.outlet_inbound_data.id}`
        )

        this.deleteDialog = false
        this.loading_approve = false

        if (response.status === 200) {
          this.showToast('success', 'Delete Success', 'Delete Item berhasil')
          this.getOutlets()
        } else {
          this.showToast('error', 'Delete Failed', 'Konfirmasi gagal')
        }
      } catch (error) {
        this.loading_approve = false
        this.showToast(
          'error',
          'Delete Failed',
          'Terjadi kesalahan pada server'
        )
        console.error('Error while deleting outlet item:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;
  .p-progressbar-value {
    background-color: #607d8b;
  }
}
.p-datatable .p-column-filter {
  display: none;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }
  .p-paginator {
    padding: 1rem;
  }
  .p-datatable-thead > tr > th {
    text-align: left;
  }
  .p-datatable-tbody > tr > td {
    cursor: auto;
  }
  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }
  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }
  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }
  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}
.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}
@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}
.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.orders-subtable {
  padding: 1rem;
}
.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}
.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }
  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }
  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }
  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}
@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }
      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }
          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
.datatable-footer-flex {
  display: flex;
  align-items: center;
  width: 100%;
  background: #fafafa;
  border-top: 1px solid #eee;
  padding: 0.5rem 0;
}
.summary-row {
  margin-top: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 4px;
  .summary-total {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    .total-label {
      font-size: 1rem;
      font-weight: 600;
      color: #495057;
    }
    .total-qty {
      font-size: 1rem;
      color: #6c757d;
    }
    .total-price {
      font-size: 1.25rem;
      font-weight: 600;
      color: #2196f3;
    }
  }
}
.card-header-flex {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1rem 1.5rem 0 1.5rem;
}
.back-btn {
  margin-left: auto;
}
</style>
